<template>
    <div class="stars">
        <div class="star"
             v-for="rating in ratings"
             :key="rating"
             :class="{ isSelected: ((value >= rating) && value != null) }"
             @click="set(rating)"
             @mouseover="starOver(rating)"
             @mouseout="startOut(rating)"
        >
            <img src="/img/icons/star.svg"
                 v-svg-inline
            >
        </div>

        <input type="hidden" name="rating" ref="stars" v-model="value">
    </div>
</template>

<script>
import { reactive, toRefs, ref } from 'vue'

export default {

    setup() {

        const state = reactive({
            value: 3,
            ratings: [1, 2, 3, 4, 5],
            clicked: false
        })

        const stars = ref(null)

        // const emitter = inject('emitter')

        function set(rating) {
            state.clicked = rating === 1;
            state.value = rating
            // emitter.emit("rating-changed", state.value);
        }

        function starOver(rating) {
            state.value = rating
            // emitter.emit("rating-changed", state.value);
        }

        function startOut(rating) {

            if ( rating === 1 && !state.clicked )
                state.value = 1

            // emitter.emit("rating-changed", state.value);
        }

        return {
            ...toRefs(state),
            stars,
            set,
            starOver,
            startOut
        }
    }
}
</script>
